import { useTranslation } from "react-i18next";

import ActionButtonLayout from "./ActionButtonLayout";

function AddTranslationPathButtonLayout ( props ) {

    const { t } = useTranslation();

    return <ActionButtonLayout {...props}>{t("buttonName.addTranslationPath")}</ActionButtonLayout>;

}

export default AddTranslationPathButtonLayout;

